import { UseLoadScriptOptions } from '@react-google-maps/api/dist/useLoadScript';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { COUNTRY_CONFIG } from 'Douleutaras/constants/localization';

const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;

const countryCode = useLocalization().countryCode;

export const googleMapConfig: UseLoadScriptOptions = {
  id: 'google-map-script',
  googleMapsApiKey: GOOGLE_API_KEY,
  libraries: ['places'],
  language: COUNTRY_CONFIG.DEFAULT_LANGUAGE[countryCode]
};
